import { createSlice } from '@reduxjs/toolkit';
import { Article, Nullable } from '../../types';
import { takeOne } from '../../helpers/store';
import { Paginated } from '../../services/api-handlers/pagination';
import {
    createArticle,
    deleteArticle,
    getAllArticles,
    getArticle,
    listArticles,
    updateArticle,
} from '../thunks/article-thunks';
import { ReducerState } from '../configure-store';

export interface ArticleState extends ReducerState {
    data: Paginated<Article>;
    current: Nullable<Article>;
}

const initialState: ArticleState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'article',
    initialState,
    reducers: {
        resetArticleCurrent: (state: ArticleState) => {
            state.current = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(listArticles.pending, takeOne.pendingActionCase)
            .addCase(listArticles.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })
            .addCase(listArticles.rejected, takeOne.rejectedActionCase)

            .addCase(getAllArticles.pending, takeOne.pendingActionCase)
            .addCase(getAllArticles.fulfilled, takeOne.fulfilledActionCase)
            .addCase(getAllArticles.rejected, takeOne.rejectedActionCase)

            .addCase(getArticle.pending, takeOne.pendingActionCase)
            .addCase(getArticle.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.current = action.payload;
            })
            .addCase(getArticle.rejected, takeOne.rejectedActionCase)

            .addCase(createArticle.pending, takeOne.pendingActionCase)
            .addCase(createArticle.fulfilled, takeOne.fulfilledActionCase)
            .addCase(createArticle.rejected, takeOne.rejectedActionCase)

            .addCase(updateArticle.pending, takeOne.pendingActionCase)
            .addCase(updateArticle.fulfilled, takeOne.fulfilledActionCase)
            .addCase(updateArticle.rejected, takeOne.rejectedActionCase)

            .addCase(deleteArticle.pending, takeOne.pendingActionCase)
            .addCase(deleteArticle.fulfilled, takeOne.fulfilledActionCase)
            .addCase(deleteArticle.rejected, takeOne.rejectedActionCase);
    },
});

export const { resetArticleCurrent } = slice.actions;

export default slice.reducer;
